import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Message from '../../components/Message';
import {setMessageShow, setMessageText} from './messageSlice';
import {sleep} from '../../utils/helpers';

function MessageFeature() {
  const dispatch = useDispatch();
  const {flash, text, type, show, autoHideDuration} = useSelector(
    state => state.message
  );

  /** Flash messages are auto-hidden by the Snackbar, inline alerts are not */
  useEffect(() => {
    if (!show || flash) {
      return undefined;
    }
    const timeout = setTimeout(() => {
      dispatch(setMessageShow(false));
    }, autoHideDuration);
    return () => clearTimeout(timeout);
  }, [autoHideDuration, dispatch, flash, show]);

  const handleClose = () => {
    dispatch(setMessageShow(false));
    sleep(200).then(() => {
      dispatch(setMessageText(''));
    });
  };

  return (
    <Message
      autoHideDuration={autoHideDuration}
      flash={flash}
      text={text}
      show={show}
      type={type}
      onClose={flash ? handleClose : undefined}
    />
  );
}

export default MessageFeature;
